import { type HeaderAppState } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type SetSearchBarVisibleActionData, type SetStickyActionData, type ToggleMenuOpenActionData } from "./actions";

export const initialState: HeaderAppState = {
  isSticky: false,
  isMenuOpen: false,
  isSearchBarVisible: false
};

export default (state: HeaderAppState = initialState, action: ReduxAction<any>): HeaderAppState => {
  switch (action.type) {
    case Actions.SetSticky: {
      const { isSticky } = action.data as SetStickyActionData;
      return {
        ...state,
        isSticky
      };
    }
    case Actions.SetSearchBarVisible:
      const { isVisible } = action.data as SetSearchBarVisibleActionData;
      return {
        ...state,
        isSearchBarVisible: isVisible
      };
    case Actions.ToggleMenuOpen:
      const { isOpen } = action.data as ToggleMenuOpenActionData;
      return {
        ...state,
        isMenuOpen: isOpen
      };
    default:
      return state;
  }
};
